<!-- Navigation -->
<nav class="navbar navbar-custom " role="navigation">
          <div class="dropdown">
            <span> <a (click)= "profileIconClick()"><img class="profile_image" src = "./assets/img/user.png"></a></span>
            <div class="dropdown-content">
<!--               <a class="page-scroll" (click)= "register1Click()" style="cursor: pointer;" i18n>Register</a> -->
              <a class="page-scroll" (click)= "profileClick()" style="cursor: pointer;" i18n>Profile</a>
      <a *ngIf="is_country_fp" class="page-scroll" (click)= "manageTeamClick()" style="cursor: pointer;" i18n>Manage Team</a>
              <a class="page-scroll" (click)= "feedbackClick()" style="cursor: pointer;" i18n>Feedback</a>
              <a class="page-scroll" (click)= "logoutClick()" style="cursor: pointer;" i18n>Logout</a>
            </div>
          </div>
        <lang-change></lang-change>
        <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-main-collapse">
                Menu <i class="fa fa-bars"></i>
            </button>
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse navbar-main-collapse">
            <ul class="nav navbar-nav" appDynamicDirection>
                <!-- Hidden li included to remove active class from introduction link when scrolled up past introduction section -->
                <li class="hidden">
                    <a href="#page-top"></a>
                </li>
                <li>
                  <a class="page-scroll intro-ecourse" (click) = "courseButtonClick()" i18n="@@Ecourse short">Online course</a>
              </li>

              <li>
                <a class="page-scroll intro-summary" (click) = "summaryButtonClick()" i18n="@@Summary View short">Summary View</a>
            </li>

            <li>
              <a class="page-scroll intro-four" (click) = "fourElementButtonClick()" i18n="@@intro header Four Elements">Two Elements</a>
          </li>


          <li>
            <a class="page-scroll intro-overview" (click) = "overviewButtonClick()" i18n="@@intro header Overview">Overview</a>
        </li>


        <li>
          <a class="page-scroll intro-intro header_active" (click) = "introButtonClick()" i18n="@@intro header Introduction">Introduction</a>
      </li>

                <li>
                    <a class="page-scroll intro-home" (click) = "homeButtonClick()" i18n="@@intro header Home">Home</a>
                </li>



            </ul>
        </div>
        <!-- /.navbar-collapse -->
    </div>
    <!-- /.container -->
</nav>



// WEBPACK FOOTER //
// ./src/app/header/header.component.html